export default __webpack_public_path__ + "static/media/Bangkok.bf79608d.png";